<!-- Tabs de tubos -->
<div class="row" *ngIf="tubos.length > 0" style="margin-bottom: 10px;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <mat-tab-group [selectedIndex]="selectedTabIndex"
                        (selectedTabChange)="onTuboChange($event.index)"
                        mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab *ngFor="let tubo of tubos" [label]="tubo.business_name | uppercase">
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

<!-- LOADING -->
<div class=" row" *ngIf="loading">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn container-loading">
        <div class="img-loading">
            <img src="../../assets/img/loading.png" class="img-loading1">
        </div>
        <div style="margin-top: 20px;">
            <mat-label class="label-loading">
                <div>La información está siendo procesada.</div>
                <div>Esto no tomará mucho tiempo.</div>
            </mat-label>
        </div>
    </div>
</div>

<!-- Mensaje de vacío en la vista general -->

<div class=" row" *ngIf="!hasData && !loading">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 container-loading">
        <div class="img-loading">
            <i class="fa-regular fa-print-magnifying-glass"></i>
        </div>
        <div class="text-loading">
            <mat-label class="label-loading">
                <div>¡Ups! Al parecer, no tienes inversiones vigentes para visualizar.</div>
            </mat-label>
        </div>
    </div>
</div>



<!-- Contenido general con datos -->
<div class="row" *ngIf="hasData && !loading">

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
        <h1 class="titulo-simpli">Información general</h1>
    </div>

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="badge-ceo-new" style="margin-top: 10px;">
            <div class="box-badge animate__animated animate__fadeIn">
                <div class="label-user-box-badge">
                    <span>${{(total_amount | formatting: 'money' )}}</span>
                </div>
                <small>Capital invertido</small>
            </div>

            <div class="box-badge animate__animated animate__fadeIn">
                <div class="label-user-box-badge">
                    <span>${{(total_profit | formatting: 'money' )}}</span>
                </div>
                <small>Ganancias acumuladas</small>
            </div>

            <div class="box-badge animate__animated animate__fadeIn">
                <div class="label-user-box-badge">
                    <span>${{ (total_investment_at_exp) | formatting: 'money' }}</span>
                </div>
                <small>Inversión al vencimiento</small>
            </div>

            <div class="box-badge animate__animated animate__fadeIn">
                <div class="label-user-box-badge">
                    <span>{{(rentabilidad_al_venc | formatting: 'rate' )}}</span>
                </div>
                <small>Rentabilidad</small>
            </div>

            <div class="box-badge animate__animated animate__fadeIn">
                <div class="label-user-box-badge">
                    <span>{{ (total_profit - total_profit_at_exp) | customCurrency }}</span>
                </div>
                <small>Si retiro anticipado, dejo de ganar</small>
            </div>

            <div class="box-badge animate__animated animate__fadeIn" (click)="open_account()">
                <div class="label-user-box-badge">
                    <span class="material-icons">
                        add_card
                    </span>
                </div>
                <small>Cuenta bancaria</small>
            </div>

        </div>
    </div>


    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <mat-card>
            <app-chart-retiro-hoy [title]="'Retiro hoy'" />
        </mat-card>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <mat-card>
            <app-chart-al-vencimiento [title]="'Retiro al vencimiento'" />
        </mat-card>
    </div>

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <mat-card>
            <app-chart-inversion [title]="'Inversión'" />
        </mat-card>
    </div>

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <mat-card>
            <mat-card-content>
                <h1 class="titulo-simpli">Detalle inversiones</h1>
                <div class="table-responsive-simpli add_factoring">
                    <table mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="folio">
                            <th mat-header-cell *matHeaderCellDef>Folio</th>
                            <td mat-cell *matCellDef="let element">
                                <input class="no-input" readonly value="{{element.folio}}">
                            </td>
                            <td mat-footer-cell *matFooterCellDef> Total </td>
                        </ng-container>

                        <ng-container matColumnDef="capital">
                            <th mat-header-cell *matHeaderCellDef>Suma de capital</th>
                            <td mat-cell *matCellDef="let element">
                                <input class="no-input" readonly value="${{ element.capital | formatting: 'money' }}">
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                                ${{(total_amount | formatting: 'money' )}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="ganancia_actual">
                            <th mat-header-cell *matHeaderCellDef>Suma de valor presente inversión</th>
                            <td mat-cell *matCellDef="let element">
                                <input class="no-input" readonly
                                    value="${{(element.ganancia_actual + element.capital) | formatting: 'money'}}">
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                                ${{(total_profit_cap | formatting: 'money' )}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="inversion_al_vencimiento">
                            <th mat-header-cell *matHeaderCellDef>Suma de inversión al vencimiento</th>
                            <td mat-cell *matCellDef="let element">
                                <input class="no-input" readonly
                                    value="${{(element.inversion_al_vencimiento) | formatting: 'money' }}">
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                                ${{(total_investment_at_exp) | formatting: 'money' }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="tasa">
                            <th mat-header-cell *matHeaderCellDef>Tasa</th>
                            <td mat-cell *matCellDef="let element">
                                <input class="no-input" readonly value="{{(element.tasa | formatting: 'rate')}}">
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                                <div style="white-space: nowrap;">
                                    {{(average_rate) | formatting: 'rate' }}
                                    <span matTooltip="Tasa Promedio"><i class="fa-regular fa-circle-info"></i></span>
                                </div>
                            </td>
                        </ng-container>
                        

                        <ng-container matColumnDef="rentabilidad_hoy">
                            <th mat-header-cell *matHeaderCellDef>Rentabilidad hoy</th>
                            <td mat-cell *matCellDef="let element">
                                <input class="no-input" readonly
                                    value="{{ element.rentabilidad_hoy | formatting: 'rate' }}">
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                                {{(rentabilidad_hoy) | formatting: 'rate' }}
                                <span matTooltip="Rentabilidad Promedio"><i
                                        class="fa-regular fa-circle-info"></i></span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="rentabilidad_venc">
                            <th mat-header-cell *matHeaderCellDef>Rentabilidad al vencimiento</th>
                            <td mat-cell *matCellDef="let element">
                                <input class="no-input" readonly
                                    value="{{ element.rentabilidad_al_venc | formatting: 'rate' }}">
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                                {{(rentabilidad_al_venc) | formatting: 'rate' }}
                                <span matTooltip="Rentabilidad Promedio"><i
                                        class="fa-regular fa-circle-info"></i></span>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="fecha_de_vencimiento">
                            <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
                            <td mat-cell *matCellDef="let element">
                                <input class="no-input" readonly
                                    value="{{(element.fecha_de_vencimiento | formatting: 'date')}}">
                            </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>

                        <ng-container matColumnDef="obs">
                            <th mat-header-cell *matHeaderCellDef>Observaciones
                            <th>
                            <td mat-cell *matCellDef="let element">
                                <span (click)="openObs(element.folio, element.pk)">
                                    <i class="fa-duotone fa-comments" style="color:#000467;cursor: pointer;"></i>
                                </span>
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                                <input class="no-input footer" readonly value="">
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef>Acciones
                            <th>
                            <td mat-cell *matCellDef="let element">
                                <app-acciones [folio]="element.folio" [pk]="element.pk" [tasa]="element.tasa" [generateMutual]="element.generate_mutual" [tipoContrato]="element.tipo_contrato" [status_document]="element.status_document"></app-acciones>
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                                <input class="no-input footer" readonly value="">
                            </td>
                        </ng-container>



                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                            class="example-element-row row-doc">
                        </tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                    </table>
                </div>
            </mat-card-content>
        </mat-card>
    </div>    

</div>